import { render, staticRenderFns } from "./system_school_management.vue?vue&type=template&id=198d344a&scoped=true&"
import script from "./system_school_management.vue?vue&type=script&lang=js&"
export * from "./system_school_management.vue?vue&type=script&lang=js&"
import style0 from "./system_school_management.vue?vue&type=style&index=0&id=198d344a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198d344a",
  null
  
)

export default component.exports